import React, { Component } from "react";
import PopupForm from "./PopupForm";

class Rodape extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPopup: false,
      formData: {
        nome: "",
        telefone: "",
        formValido: true,
        enviado: false,
        msg_enviado: "",
      },
    };
  }

  abrirPopup = () => {
    this.setState({ openPopup: true });
  };

  fecharPopup = () => {
    this.setState(prevState => ({
      ...prevState,
      openPopup: false,
    }));
  };

  enviarFormulario = async (formData) => {
    const { nome, telefone } = formData;

    if (!nome || !telefone) {
      // Validação simples
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Por favor, preencha todos os campos.",
        },
      }));
      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);
      return;
    }

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        enviado: true,
        msg_enviado: "Enviando mensagem...",
      },
    }));

    // Monta a mensagem em HTML
    const mensagem = `Nome: ${nome}<br>Telefone: ${telefone}`;

    // Lista de destinatários (substitua pelo email do vendedor)
    const destinatarios = ["uberveiculos@hotmail.com"];

    try {
      const fetchPromises = destinatarios.map(email => {
        return fetch(
          "https://us-central1-intermedio-1513801146022.cloudfunctions.net/enviarEmail",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              remetente: "Contato Site Uber Veículos <uberveiculos@hotmail.com>",
              assunto: "Contato pelo site",
              destinatarios: email,
              corpo: mensagem,
              corpoHtml: mensagem,
            }),
          }
        );
      });

      await Promise.all(fetchPromises);

      // Mensagem de sucesso
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Mensagem enviada com sucesso!",
          nome: "",
          telefone: "",
        },
      }));

      // Fecha a mensagem após alguns segundos
      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);

    } catch (error) {
      // Mensagem de erro
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          enviado: true,
          msg_enviado: "Erro ao enviar mensagem. Tente novamente mais tarde.",
        },
      }));

      setTimeout(() => {
        this.setState(prevState => ({
          formData: { ...prevState.formData, enviado: false }
        }));
      }, 4000);

      console.error("Erro no envio do formulário:", error);
    }
  };


  render() {
    const { revenda } = this.props;
    const { openPopup, formData } = this.state;

    return (
      <>
        <footer className="footer-3 footer-topbar light page-section-pt"> 
          <div className="container">
            <div className="row top">
              <div className="col-lg-3 col-md-12">
                <img
                  className="img-fluid"
                  id="logo_footer_dark"
                  src="images/logo.png"
                  alt=""
                />
              </div>

              <div className="col-lg-4 col-md-12">
                {/* Botão flutuante do WhatsApp */}
                {/*<button
                  className="data-collection-button"
                  onClick={this.abrirPopup}
                >
                  <i className="fa fa-envelope-o"></i>
                </button>*/}
              </div>
            </div>

            {/* Sobre nós */}
            <div className="row" style={{ justifyContent: "center", textAlign: "center" }}>
              <div className="col-lg-5 col-md-12">
                <div className="about-content">
                  <h6 className="text-sobrenos">Sobre nós</h6>
                  <p className="text-sobrenos-info">
                    Na Titanium Automóveis você encontra o seu seminovo com garantia e procedência.Compra,venda e financiamento. Aproveite as melhores ofertas com grande variedade em estoque.
                  </p>
                </div>
              </div>

              {/* Informações da loja */}
              <div className="col-lg-7 col-md-12">
                <h6 className="text-sobrenos">Informações da loja</h6>
                <ul className="text-sobrenos-info">
                  <li>{revenda.peendereco_fiscal} - {revenda.peendereco_fiscal_numero} - {revenda.pebairro_fiscal} - {revenda.pecidade} - {revenda.peuf}</li>
                  <li>Rua Andrade Neves - 583 - Vila Helena - Santo André - SP</li>
                  <li>{revenda.petelefone1}</li>
                  <li>{revenda.petelefone2}</li>
                  <li>{revenda.petelefone3}</li>
                  <li>
                    <i className="fa fa-envelope-o" style={{ marginRight: "10px" }}></i>
                    <a href={"mailto:" + revenda.peemail}>{revenda.peemail}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

        {/* Popup Form */}
        <PopupForm
          open={openPopup}
          onClose={this.fecharPopup}
          onSubmit={this.enviarFormulario}
          state={formData}
        />
      </>
    );
  }
}

export default Rodape;
